import React, { useState } from "react";
import "./cards.css";

const items = [
  {
    image: require("../../assets/vivre/HospitalityLogo.png"),
    title: "VIVRE",
    description: "Experience. Engage. Monetize",
    details: [
      "User-friendly SAAS platform",
      "CMS-ready & real-time updates",
      "Immersive UI/UX interface",
      "Standard APIs & analytics",
    ],
  },
  {
    image: require("../../assets/nsara/f2576786-dfec-449f-9b0b-b820983d0f0d-removebg-preview.png"),
    title: "CONTENT EYE",
    description: "AI Content Intelligence & Governance",
    details: [
      "Multimodal content analysis",
      "Automated quality validation",
      "Compliance & Governance",
      "Metadata-driven discovery",
    ],
  },
  {
    image: require("../../assets/products/reelcraft-removebg-preview.png"),
    title: "ReelCraft",
    description: "Promote Content. Enrich Metadata. Commercialize",
    details: [
      "Create & edit videos",
      "Enhance with effects",
      "Easy share options",
      "Built for engagement",
    ],
  },
  {
    image: require("../../assets/aboutus/Sara.png"),
    title: "S.A.R.A",
    description: "Content Discovery. Immersive. Monetize",
    details: [
      "AI-powered UX platform",
      "Smart content discovery",
      "Gamified monetization",
      "Usage insights & APIs",
    ],
  },
  {
    image: require("../../assets/products/HZAD.png"),
    title: "AdPilot",
    description: "Promote. Analytics. Monetize",
    details: [
      "Simplified ad tools",
      "Target & monetize",
      "Real-time performance",
      "Integrated dashboard",
    ],
  },
  {
    image: require("../../assets/hospitality/logo1.png"),
    title: "Hospitality",
    description: "Entertainment. Hotel Service Aggregation",
    details: [
      "OTT hotel experience",
      "Unified guest services",
      "PMS-ready APIs",
      "CMS integrated tools",
    ],
  },
  {
    image: require("../../assets/nblink/Saralogo.png"),
    title: "BLINKS",
    description: "User Generated Content. Gamification",
    details: [
      "UGC video platform",
      "Ad & commerce tools",
      "Gamified engagement",
      "Mobile-first design",
    ],
  },
];


const Carousel = () => {
  const [current, setCurrent] = useState(0);

  const rotate = (direction) => {
    setCurrent((prev) => (prev + direction + items.length) % items.length);
  };

  return (
    <div className="card-carousel-container">
      <div className="card-carousel-scene">
        <div
          className="card-carousel-wrapper"
          style={{
           
            transform: `rotateY(-${(360 / items.length) * current}deg)`,
          }}
        >
          {items.map((item, index) => {
            const angle = (360 / items.length) * index;
            const isActive = index === current;

            return (
              <div
                key={index}
                className={`card-carousel-item ${isActive ? "active" : ""}`}
                style={{
                  transform: `rotateY(${angle}deg) translateZ(500px)`,
                  paddingBottom:"10px"
                }}
              >
                <img src={item.image} alt={item.title} />
                <h2>{item.title}</h2>
                <p style={{ color: "#2a5298" }}>{item.description}</p>
                <ul className="card-ul"
                >
                  {item?.details?.map((ele, index) => (
                    <li
                      key={index}
                      style={{ marginBottom: "8px", width: "100%" }}
                    >
                      {ele}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
      <div className="card-carousel-controls">
        <button onClick={() => rotate(-1)}>&larr;</button>
        <button onClick={() => rotate(1)}>&rarr;</button>
      </div>
    </div>
  );
};

export default Carousel;
